var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatMainTabIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.0833C20.5028 11.1832 20.2459 12.2682 19.75 13.25C19.162 14.4265 18.2581 15.416 17.1395 16.1077C16.0209 16.7995 14.7319 17.1662 13.4167 17.1667C12.3168 17.1695 11.2318 16.9126 10.25 16.4167L5.5 18L7.08333 13.25C6.58744 12.2682 6.33046 11.1832 6.33333 10.0833C6.33384 8.76815 6.70051 7.47906 7.39226 6.36048C8.08402 5.24189 9.07354 4.33799 10.25 3.75002C11.2318 3.25413 12.3168 2.99716 13.4167 3.00002H13.8333C15.5703 3.09585 17.2109 3.82899 18.4409 5.05907C19.671 6.28915 20.4041 7.92973 20.5 9.66668V10.0833Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMainTabIcon);
export default __webpack_public_path__ + "static/media/chat-main-tab-icon.a946268339e35eb566319f47c74dc465.svg";
export { ForwardRef as ReactComponent };